import { css } from "@emotion/react";

export const secondMenuStyle = css`
  padding-left: 54px !important;
`;

export const thirdMenuStyle = css`
  padding-left: 84px !important;
`;

export const menuIconStyle = css`
  width: 20px;
  height: 20px;
`;
